import React from "react";
import { withStyles, withTheme, Grid } from "@material-ui/core";
import { compose } from "recompose";
import MilesPopup from "./MilesPopup";
import StopInfo from "./StopInfo";
import CustomerMergeIndicator from "../../../../common/CustomerMergeIndicator";

const styles = (theme) => ({
  smallText: {
    fontWeight: "600",
    fontSize: theme.headerTextFontSize,
    lineHeight: "22px",
    textDecorationLine: "underline",
    color: theme.stopNameColor,
  },
  topPadding: {
    paddingTop: "24px",
  },
  flexRowCenter: {
    display: "flex",
    alignItems: "center",
  },
  detailContainer: {
    minHeight: 300,
  },
});

const StopDetails = ({ classes, stopDetails }) => {
  const plannedNextStop = stopDetails.plannedNextStop;
  const actualNextStop = stopDetails.actualNextStop;
  return (
    <Grid container className={classes.topPadding}>
      <Grid container>
        <div className={classes.flexRowCenter}>
          <div className={classes.smallText}>
            {`At ${stopDetails.data.displayCustomerName}`}
            <CustomerMergeIndicator
              displayCustomerName={stopDetails.data.displayCustomerName}
              customerName={stopDetails.data.name}
            />
          </div>
          {stopDetails.milesAdded !== 0 && (
            <MilesPopup milesAdded={stopDetails.milesAdded} />
          )}
        </div>
      </Grid>
      <Grid container className={classes.detailContainer}>
        {plannedNextStop?.data && (
          <Grid item xs={6}>
            <StopInfo
              stopDetails={plannedNextStop}
              isDeviation={stopDetails.isDeviation}
              manifestNumber={stopDetails.manifestNumber}
              stopLabel="Planned Next Stop"
            />
          </Grid>
        )}
        {actualNextStop?.data && (
          <Grid item xs={6}>
            <StopInfo
              stopDetails={actualNextStop}
              isDeviation={stopDetails.isDeviation}
              manifestNumber={stopDetails.manifestNumber}
              stopLabel="Actual Next Stop"
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
export default compose(withStyles(styles), withTheme())(StopDetails);
